import * as React from 'react';
export const visibleColumnsIcon = (
  <svg
    width="104"
    height="74"
    viewBox="0 0 104 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="103.827" height="73.752" rx="5" fill="white" />
    <path
      d="M7 9C7 7.89543 7.89543 7 9 7H57.4727V14.4141H9C7.89543 14.4141 7 13.5186 7 12.4141V9Z"
      fill="#3385FF"
    />
    <rect
      x="7"
      y="17.4141"
      width="11.1182"
      height="49.3379"
      rx="2"
      fill="#99C2FF"
    />
    <rect
      x="20.1182"
      y="17.4141"
      width="11.1182"
      height="49.3379"
      rx="2"
      fill="#99C2FF"
    />
    <rect
      x="33.2363"
      y="17.4141"
      width="11.1182"
      height="49.3379"
      rx="2"
      fill="#99C2FF"
    />
    <rect
      x="46.3545"
      y="17.4141"
      width="11.1182"
      height="49.3379"
      rx="2"
      fill="#99C2FF"
    />
    <path
      d="M59.4727 7H94.8271C95.9317 7 96.8271 7.89543 96.8271 9V12.4141C96.8271 13.5186 95.9317 14.4141 94.8271 14.4141H59.4727V7Z"
      fill="#A2B2CF"
    />
    <rect
      x="59.4727"
      y="17.4141"
      width="11.1182"
      height="49.3379"
      rx="2"
      fill="#EBEEF4"
    />
    <rect
      x="72.5908"
      y="17.4141"
      width="11.1182"
      height="49.3379"
      rx="2"
      fill="#EBEEF4"
    />
    <rect
      x="85.709"
      y="17.4141"
      width="11.1182"
      height="49.3379"
      rx="2"
      fill="#EBEEF4"
    />
  </svg>
);

export const allColumnsIcon = (
  <svg
    width="104"
    height="74"
    viewBox="0 0 104 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="103.827" height="73.752" rx="5" fill="white" />
    <path
      d="M7 9C7 7.89543 7.89543 7 9 7H57.4727V14.4141H9C7.89543 14.4141 7 13.5186 7 12.4141V9Z"
      fill="#3385FF"
    />
    <rect
      x="7"
      y="17.4141"
      width="11.1182"
      height="49.3379"
      rx="2"
      fill="#99C2FF"
    />
    <rect
      x="20.1182"
      y="17.4141"
      width="11.1182"
      height="49.3379"
      rx="2"
      fill="#99C2FF"
    />
    <rect
      x="33.2363"
      y="17.4141"
      width="11.1182"
      height="49.3379"
      rx="2"
      fill="#99C2FF"
    />
    <rect
      x="46.3545"
      y="17.4141"
      width="11.1182"
      height="49.3379"
      rx="2"
      fill="#99C2FF"
    />
    <path
      d="M59.4727 7H94.8271C95.9317 7 96.8271 7.89543 96.8271 9V12.4141C96.8271 13.5186 95.9317 14.4141 94.8271 14.4141H59.4727V7Z"
      fill="#002D70"
    />
    <rect
      x="59.4727"
      y="17.4141"
      width="11.1182"
      height="49.3379"
      rx="2"
      fill="#004EC2"
    />
    <rect
      x="72.5908"
      y="17.4141"
      width="11.1182"
      height="49.3379"
      rx="2"
      fill="#004EC2"
    />
    <rect
      x="85.709"
      y="17.4141"
      width="11.1182"
      height="49.3379"
      rx="2"
      fill="#004EC2"
    />
  </svg>
);

export const noColumnsAllRowsIcon = (
  <svg
    width="104"
    height="74"
    viewBox="0 0 104 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="103.827" height="73.752" rx="5" fill="white" />
    <path
      d="M7 9C7 7.89543 7.89543 7 9 7H94.8272C95.9317 7 96.8271 7.89543 96.8271 9V12.4141C96.8271 13.5186 95.9317 14.4141 94.8271 14.4141H9C7.89543 14.4141 7 13.5186 7 12.4141V9Z"
      fill="#3385FF"
    />
    <path
      d="M7 19.4141C7 18.3095 7.89543 17.4141 9 17.4141H18.1182V25.6816H9C7.89543 25.6816 7 24.7862 7 23.6816V19.4141Z"
      fill="#99C2FF"
    />
    <path
      d="M7 29.6816C7 28.5771 7.89543 27.6816 9 27.6816H18.1182V35.9492H9C7.89543 35.9492 7 35.0538 7 33.9492V29.6816Z"
      fill="#99C2FF"
    />
    <path
      d="M7 39.9492C7 38.8446 7.89543 37.9492 9 37.9492H18.1182V46.2168H9C7.89543 46.2168 7 45.3214 7 44.2168V39.9492Z"
      fill="#99C2FF"
    />
    <path
      d="M7 50.2168C7 49.1122 7.89543 48.2168 9 48.2168H18.1182V56.4844H9C7.89543 56.4844 7 55.5889 7 54.4844V50.2168Z"
      fill="#99C2FF"
    />
    <path
      d="M7 60.4844C7 59.3798 7.89543 58.4844 9 58.4844H18.1182V66.752H9C7.89543 66.752 7 65.8565 7 64.752V60.4844Z"
      fill="#99C2FF"
    />
    <path
      d="M20.1182 17.4141H31.2363V25.6816H20.1182V17.4141Z"
      fill="#99C2FF"
    />
    <path
      d="M20.1182 27.6816H31.2363V35.9492H20.1182V27.6816Z"
      fill="#99C2FF"
    />
    <path
      d="M20.1182 37.9492H31.2363V46.2168H20.1182V37.9492Z"
      fill="#99C2FF"
    />
    <path
      d="M20.1182 48.2168H31.2363V56.4844H20.1182V48.2168Z"
      fill="#99C2FF"
    />
    <path d="M20.1182 58.4844H31.2363V66.752H20.1182V58.4844Z" fill="#99C2FF" />
    <path
      d="M33.2363 17.4141H44.3545V25.6816H33.2363V17.4141Z"
      fill="#99C2FF"
    />
    <path
      d="M33.2363 27.6816H44.3545V35.9492H33.2363V27.6816Z"
      fill="#99C2FF"
    />
    <path
      d="M33.2363 37.9492H44.3545V46.2168H33.2363V37.9492Z"
      fill="#99C2FF"
    />
    <path
      d="M33.2363 48.2168H44.3545V56.4844H33.2363V48.2168Z"
      fill="#99C2FF"
    />
    <path d="M33.2363 58.4844H44.3545V66.752H33.2363V58.4844Z" fill="#99C2FF" />
    <path
      d="M46.3545 17.4141H57.4727V25.6816H46.3545V17.4141Z"
      fill="#99C2FF"
    />
    <path
      d="M46.3545 27.6816H57.4727V35.9492H46.3545V27.6816Z"
      fill="#99C2FF"
    />
    <path
      d="M46.3545 37.9492H57.4727V46.2168H46.3545V37.9492Z"
      fill="#99C2FF"
    />
    <path
      d="M46.3545 48.2168H57.4727V56.4844H46.3545V48.2168Z"
      fill="#99C2FF"
    />
    <path d="M46.3545 58.4844H57.4727V66.752H46.3545V58.4844Z" fill="#99C2FF" />
    <path
      d="M59.4727 17.4141H70.5908V25.6816H59.4727V17.4141Z"
      fill="#99C2FF"
    />
    <path
      d="M59.4727 27.6816H70.5908V35.9492H59.4727V27.6816Z"
      fill="#99C2FF"
    />
    <path
      d="M59.4727 37.9492H70.5908V46.2168H59.4727V37.9492Z"
      fill="#99C2FF"
    />
    <path
      d="M59.4727 48.2168H70.5908V56.4844H59.4727V48.2168Z"
      fill="#99C2FF"
    />
    <path d="M59.4727 58.4844H70.5908V66.752H59.4727V58.4844Z" fill="#99C2FF" />
    <path d="M72.5908 17.4141H83.709V25.6816H72.5908V17.4141Z" fill="#99C2FF" />
    <path d="M72.5908 27.6816H83.709V35.9492H72.5908V27.6816Z" fill="#99C2FF" />
    <path d="M72.5908 37.9492H83.709V46.2168H72.5908V37.9492Z" fill="#99C2FF" />
    <path d="M72.5908 48.2168H83.709V56.4844H72.5908V48.2168Z" fill="#99C2FF" />
    <path d="M72.5908 58.4844H83.709V66.752H72.5908V58.4844Z" fill="#99C2FF" />
    <path
      d="M85.709 17.4141H94.8271C95.9317 17.4141 96.8271 18.3095 96.8271 19.4141V23.6816C96.8271 24.7862 95.9317 25.6816 94.8271 25.6816H85.709V17.4141Z"
      fill="#99C2FF"
    />
    <path
      d="M85.709 27.6816H94.8271C95.9317 27.6816 96.8271 28.5771 96.8271 29.6816V33.9492C96.8271 35.0538 95.9317 35.9492 94.8271 35.9492H85.709V27.6816Z"
      fill="#99C2FF"
    />
    <path
      d="M85.709 37.9492H94.8271C95.9317 37.9492 96.8271 38.8446 96.8271 39.9492V44.2168C96.8271 45.3214 95.9317 46.2168 94.8271 46.2168H85.709V37.9492Z"
      fill="#99C2FF"
    />
    <path
      d="M85.709 48.2168H94.8271C95.9317 48.2168 96.8271 49.1122 96.8271 50.2168V54.4844C96.8271 55.5889 95.9317 56.4844 94.8271 56.4844H85.709V48.2168Z"
      fill="#99C2FF"
    />
    <path
      d="M85.709 58.4844H94.8271C95.9317 58.4844 96.8271 59.3798 96.8271 60.4844V64.752C96.8271 65.8565 95.9317 66.752 94.8271 66.752H85.709V58.4844Z"
      fill="#99C2FF"
    />
  </svg>
);

export const noColumnsCheckedRowsIcon = (
  <svg
    width="104"
    height="74"
    viewBox="0 0 104 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="103.827" height="73.752" rx="5" fill="white" />
    <path
      d="M7 9C7 7.89543 7.89543 7 9 7H94.8272C95.9317 7 96.8271 7.89543 96.8271 9V12.4141C96.8271 13.5186 95.9317 14.4141 94.8271 14.4141H9C7.89543 14.4141 7 13.5186 7 12.4141V9Z"
      fill="#3385FF"
    />
    <path
      d="M7 19.4141C7 18.3095 7.89543 17.4141 9 17.4141H18.1182V25.6816H9C7.89543 25.6816 7 24.7862 7 23.6816V19.4141Z"
      fill="#99C2FF"
    />
    <path
      d="M7 29.6816C7 28.5771 7.89543 27.6816 9 27.6816H18.1182V35.9492H9C7.89543 35.9492 7 35.0538 7 33.9492V29.6816Z"
      fill="#99C2FF"
    />
    <path
      d="M7 39.9492C7 38.8446 7.89543 37.9492 9 37.9492H18.1182V46.2168H9C7.89543 46.2168 7 45.3214 7 44.2168V39.9492Z"
      fill="#99C2FF"
    />
    <path
      d="M7 50.2168C7 49.1122 7.89543 48.2168 9 48.2168H18.1182V56.4844H9C7.89543 56.4844 7 55.5889 7 54.4844V50.2168Z"
      fill="#EBEEF4"
    />
    <path
      d="M7 60.4844C7 59.3798 7.89543 58.4844 9 58.4844H18.1182V66.752H9C7.89543 66.752 7 65.8565 7 64.752V60.4844Z"
      fill="#EBEEF4"
    />
    <path
      d="M20.1182 17.4141H31.2363V25.6816H20.1182V17.4141Z"
      fill="#99C2FF"
    />
    <path
      d="M20.1182 27.6816H31.2363V35.9492H20.1182V27.6816Z"
      fill="#99C2FF"
    />
    <path
      d="M20.1182 37.9492H31.2363V46.2168H20.1182V37.9492Z"
      fill="#99C2FF"
    />
    <path
      d="M20.1182 48.2168H31.2363V56.4844H20.1182V48.2168Z"
      fill="#EBEEF4"
    />
    <path d="M20.1182 58.4844H31.2363V66.752H20.1182V58.4844Z" fill="#EBEEF4" />
    <path
      d="M33.2363 17.4141H44.3545V25.6816H33.2363V17.4141Z"
      fill="#99C2FF"
    />
    <path
      d="M33.2363 27.6816H44.3545V35.9492H33.2363V27.6816Z"
      fill="#99C2FF"
    />
    <path
      d="M33.2363 37.9492H44.3545V46.2168H33.2363V37.9492Z"
      fill="#99C2FF"
    />
    <path
      d="M33.2363 48.2168H44.3545V56.4844H33.2363V48.2168Z"
      fill="#EBEEF4"
    />
    <path d="M33.2363 58.4844H44.3545V66.752H33.2363V58.4844Z" fill="#EBEEF4" />
    <path
      d="M46.3545 17.4141H57.4727V25.6816H46.3545V17.4141Z"
      fill="#99C2FF"
    />
    <path
      d="M46.3545 27.6816H57.4727V35.9492H46.3545V27.6816Z"
      fill="#99C2FF"
    />
    <path
      d="M46.3545 37.9492H57.4727V46.2168H46.3545V37.9492Z"
      fill="#99C2FF"
    />
    <path
      d="M46.3545 48.2168H57.4727V56.4844H46.3545V48.2168Z"
      fill="#EBEEF4"
    />
    <path d="M46.3545 58.4844H57.4727V66.752H46.3545V58.4844Z" fill="#EBEEF4" />
    <path
      d="M59.4727 17.4141H70.5908V25.6816H59.4727V17.4141Z"
      fill="#99C2FF"
    />
    <path
      d="M59.4727 27.6816H70.5908V35.9492H59.4727V27.6816Z"
      fill="#99C2FF"
    />
    <path
      d="M59.4727 37.9492H70.5908V46.2168H59.4727V37.9492Z"
      fill="#99C2FF"
    />
    <path
      d="M59.4727 48.2168H70.5908V56.4844H59.4727V48.2168Z"
      fill="#EBEEF4"
    />
    <path d="M59.4727 58.4844H70.5908V66.752H59.4727V58.4844Z" fill="#EBEEF4" />
    <path d="M72.5908 17.4141H83.709V25.6816H72.5908V17.4141Z" fill="#99C2FF" />
    <path d="M72.5908 27.6816H83.709V35.9492H72.5908V27.6816Z" fill="#99C2FF" />
    <path d="M72.5908 37.9492H83.709V46.2168H72.5908V37.9492Z" fill="#99C2FF" />
    <path d="M72.5908 48.2168H83.709V56.4844H72.5908V48.2168Z" fill="#EBEEF4" />
    <path d="M72.5908 58.4844H83.709V66.752H72.5908V58.4844Z" fill="#EBEEF4" />
    <path
      d="M85.709 17.4141H94.8271C95.9317 17.4141 96.8271 18.3095 96.8271 19.4141V23.6816C96.8271 24.7862 95.9317 25.6816 94.8271 25.6816H85.709V17.4141Z"
      fill="#99C2FF"
    />
    <path
      d="M85.709 27.6816H94.8271C95.9317 27.6816 96.8271 28.5771 96.8271 29.6816V33.9492C96.8271 35.0538 95.9317 35.9492 94.8271 35.9492H85.709V27.6816Z"
      fill="#99C2FF"
    />
    <path
      d="M85.709 37.9492H94.8271C95.9317 37.9492 96.8271 38.8446 96.8271 39.9492V44.2168C96.8271 45.3214 95.9317 46.2168 94.8271 46.2168H85.709V37.9492Z"
      fill="#99C2FF"
    />
    <path
      d="M85.709 48.2168H94.8271C95.9317 48.2168 96.8271 49.1122 96.8271 50.2168V54.4844C96.8271 55.5889 95.9317 56.4844 94.8271 56.4844H85.709V48.2168Z"
      fill="#EBEEF4"
    />
    <path
      d="M85.709 58.4844H94.8271C95.9317 58.4844 96.8271 59.3798 96.8271 60.4844V64.752C96.8271 65.8565 95.9317 66.752 94.8271 66.752H85.709V58.4844Z"
      fill="#EBEEF4"
    />
  </svg>
);
export const allRowsIcon = (
  <svg
    width="104"
    height="74"
    viewBox="0 0 104 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="103.827" height="73.752" rx="5" fill="white" />
    <path
      d="M7 9C7 7.89543 7.89543 7 9 7H57.4727V14.4141H9C7.89543 14.4141 7 13.5186 7 12.4141V9Z"
      fill="#3385FF"
    />
    <path
      d="M7 19.4141C7 18.3095 7.89543 17.4141 9 17.4141H18.1182V25.6816H9C7.89543 25.6816 7 24.7862 7 23.6816V19.4141Z"
      fill="#99C2FF"
    />
    <path
      d="M7 29.6816C7 28.5771 7.89543 27.6816 9 27.6816H18.1182V35.9492H9C7.89543 35.9492 7 35.0538 7 33.9492V29.6816Z"
      fill="#99C2FF"
    />
    <path
      d="M7 39.9492C7 38.8446 7.89543 37.9492 9 37.9492H18.1182V46.2168H9C7.89543 46.2168 7 45.3214 7 44.2168V39.9492Z"
      fill="#99C2FF"
    />
    <path
      d="M7 50.2168C7 49.1122 7.89543 48.2168 9 48.2168H18.1182V56.4844H9C7.89543 56.4844 7 55.5889 7 54.4844V50.2168Z"
      fill="#99C2FF"
    />
    <path
      d="M7 60.4844C7 59.3798 7.89543 58.4844 9 58.4844H18.1182V66.752H9C7.89543 66.752 7 65.8565 7 64.752V60.4844Z"
      fill="#99C2FF"
    />
    <path
      d="M20.1182 17.4141H31.2363V25.6816H20.1182V17.4141Z"
      fill="#99C2FF"
    />
    <path
      d="M20.1182 27.6816H31.2363V35.9492H20.1182V27.6816Z"
      fill="#99C2FF"
    />
    <path
      d="M20.1182 37.9492H31.2363V46.2168H20.1182V37.9492Z"
      fill="#99C2FF"
    />
    <path
      d="M20.1182 48.2168H31.2363V56.4844H20.1182V48.2168Z"
      fill="#99C2FF"
    />
    <path d="M20.1182 58.4844H31.2363V66.752H20.1182V58.4844Z" fill="#99C2FF" />
    <path
      d="M33.2363 17.4141H44.3545V25.6816H33.2363V17.4141Z"
      fill="#99C2FF"
    />
    <path
      d="M33.2363 27.6816H44.3545V35.9492H33.2363V27.6816Z"
      fill="#99C2FF"
    />
    <path
      d="M33.2363 37.9492H44.3545V46.2168H33.2363V37.9492Z"
      fill="#99C2FF"
    />
    <path
      d="M33.2363 48.2168H44.3545V56.4844H33.2363V48.2168Z"
      fill="#99C2FF"
    />
    <path d="M33.2363 58.4844H44.3545V66.752H33.2363V58.4844Z" fill="#99C2FF" />
    <path
      d="M46.3545 17.4141H57.4727V25.6816H46.3545V17.4141Z"
      fill="#99C2FF"
    />
    <path
      d="M46.3545 27.6816H57.4727V35.9492H46.3545V27.6816Z"
      fill="#99C2FF"
    />
    <path
      d="M46.3545 37.9492H57.4727V46.2168H46.3545V37.9492Z"
      fill="#99C2FF"
    />
    <path
      d="M46.3545 48.2168H57.4727V56.4844H46.3545V48.2168Z"
      fill="#99C2FF"
    />
    <path d="M46.3545 58.4844H57.4727V66.752H46.3545V58.4844Z" fill="#99C2FF" />
    <path
      d="M59.4727 7H94.8271C95.9317 7 96.8271 7.89543 96.8271 9V12.4141C96.8271 13.5186 95.9317 14.4141 94.8271 14.4141H59.4727V7Z"
      fill="#A2B2CF"
    />
    <path
      d="M59.4727 17.4141H70.5908V25.6816H59.4727V17.4141Z"
      fill="#EBEEF4"
    />
    <path
      d="M59.4727 27.6816H70.5908V35.9492H59.4727V27.6816Z"
      fill="#EBEEF4"
    />
    <path
      d="M59.4727 37.9492H70.5908V46.2168H59.4727V37.9492Z"
      fill="#EBEEF4"
    />
    <path
      d="M59.4727 48.2168H70.5908V56.4844H59.4727V48.2168Z"
      fill="#EBEEF4"
    />
    <path d="M59.4727 58.4844H70.5908V66.752H59.4727V58.4844Z" fill="#EBEEF4" />
    <path d="M72.5908 17.4141H83.709V25.6816H72.5908V17.4141Z" fill="#EBEEF4" />
    <path d="M72.5908 27.6816H83.709V35.9492H72.5908V27.6816Z" fill="#EBEEF4" />
    <path d="M72.5908 37.9492H83.709V46.2168H72.5908V37.9492Z" fill="#EBEEF4" />
    <path d="M72.5908 48.2168H83.709V56.4844H72.5908V48.2168Z" fill="#EBEEF4" />
    <path d="M72.5908 58.4844H83.709V66.752H72.5908V58.4844Z" fill="#EBEEF4" />
    <path
      d="M85.709 17.4141H94.8271C95.9317 17.4141 96.8271 18.3095 96.8271 19.4141V23.6816C96.8271 24.7862 95.9317 25.6816 94.8271 25.6816H85.709V17.4141Z"
      fill="#EBEEF4"
    />
    <path
      d="M85.709 27.6816H94.8271C95.9317 27.6816 96.8271 28.5771 96.8271 29.6816V33.9492C96.8271 35.0538 95.9317 35.9492 94.8271 35.9492H85.709V27.6816Z"
      fill="#EBEEF4"
    />
    <path
      d="M85.709 37.9492H94.8271C95.9317 37.9492 96.8271 38.8446 96.8271 39.9492V44.2168C96.8271 45.3214 95.9317 46.2168 94.8271 46.2168H85.709V37.9492Z"
      fill="#EBEEF4"
    />
    <path
      d="M85.709 48.2168H94.8271C95.9317 48.2168 96.8271 49.1122 96.8271 50.2168V54.4844C96.8271 55.5889 95.9317 56.4844 94.8271 56.4844H85.709V48.2168Z"
      fill="#EBEEF4"
    />
    <path
      d="M85.709 58.4844H94.8271C95.9317 58.4844 96.8271 59.3798 96.8271 60.4844V64.752C96.8271 65.8565 95.9317 66.752 94.8271 66.752H85.709V58.4844Z"
      fill="#EBEEF4"
    />
  </svg>
);

export const checkedRowsIcon = (
  <svg
    width="104"
    height="74"
    viewBox="0 0 104 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="103.827" height="73.752" rx="5" fill="white" />
    <path
      d="M7 9C7 7.89543 7.89543 7 9 7H57.4727V14.4141H9C7.89543 14.4141 7 13.5186 7 12.4141V9Z"
      fill="#3385FF"
    />
    <path
      d="M7 19.4141C7 18.3095 7.89543 17.4141 9 17.4141H18.1182V25.6816H9C7.89543 25.6816 7 24.7862 7 23.6816V19.4141Z"
      fill="#99C2FF"
    />
    <path
      d="M7 29.6816C7 28.5771 7.89543 27.6816 9 27.6816H18.1182V35.9492H9C7.89543 35.9492 7 35.0538 7 33.9492V29.6816Z"
      fill="#99C2FF"
    />
    <path
      d="M7 39.9492C7 38.8446 7.89543 37.9492 9 37.9492H18.1182V46.2168H9C7.89543 46.2168 7 45.3214 7 44.2168V39.9492Z"
      fill="#99C2FF"
    />
    <path
      d="M7 50.2168C7 49.1122 7.89543 48.2168 9 48.2168H18.1182V56.4844H9C7.89543 56.4844 7 55.5889 7 54.4844V50.2168Z"
      fill="#EBEEF4"
    />
    <path
      d="M7 60.4844C7 59.3798 7.89543 58.4844 9 58.4844H18.1182V66.752H9C7.89543 66.752 7 65.8565 7 64.752V60.4844Z"
      fill="#EBEEF4"
    />
    <path
      d="M20.1182 17.4141H31.2363V25.6816H20.1182V17.4141Z"
      fill="#99C2FF"
    />
    <path
      d="M20.1182 27.6816H31.2363V35.9492H20.1182V27.6816Z"
      fill="#99C2FF"
    />
    <path
      d="M20.1182 37.9492H31.2363V46.2168H20.1182V37.9492Z"
      fill="#99C2FF"
    />
    <path
      d="M20.1182 48.2168H31.2363V56.4844H20.1182V48.2168Z"
      fill="#EBEEF4"
    />
    <path d="M20.1182 58.4844H31.2363V66.752H20.1182V58.4844Z" fill="#EBEEF4" />
    <path
      d="M33.2363 17.4141H44.3545V25.6816H33.2363V17.4141Z"
      fill="#99C2FF"
    />
    <path
      d="M33.2363 27.6816H44.3545V35.9492H33.2363V27.6816Z"
      fill="#99C2FF"
    />
    <path
      d="M33.2363 37.9492H44.3545V46.2168H33.2363V37.9492Z"
      fill="#99C2FF"
    />
    <path
      d="M33.2363 48.2168H44.3545V56.4844H33.2363V48.2168Z"
      fill="#EBEEF4"
    />
    <path d="M33.2363 58.4844H44.3545V66.752H33.2363V58.4844Z" fill="#EBEEF4" />
    <path
      d="M46.3545 17.4141H57.4727V25.6816H46.3545V17.4141Z"
      fill="#99C2FF"
    />
    <path
      d="M46.3545 27.6816H57.4727V35.9492H46.3545V27.6816Z"
      fill="#99C2FF"
    />
    <path
      d="M46.3545 37.9492H57.4727V46.2168H46.3545V37.9492Z"
      fill="#99C2FF"
    />
    <path
      d="M46.3545 48.2168H57.4727V56.4844H46.3545V48.2168Z"
      fill="#EBEEF4"
    />
    <path d="M46.3545 58.4844H57.4727V66.752H46.3545V58.4844Z" fill="#EBEEF4" />
    <path
      d="M59.4727 7H94.8271C95.9317 7 96.8271 7.89543 96.8271 9V12.4141C96.8271 13.5186 95.9317 14.4141 94.8271 14.4141H59.4727V7Z"
      fill="#A2B2CF"
    />
    <path
      d="M59.4727 17.4141H70.5908V25.6816H59.4727V17.4141Z"
      fill="#EBEEF4"
    />
    <path
      d="M59.4727 27.6816H70.5908V35.9492H59.4727V27.6816Z"
      fill="#EBEEF4"
    />
    <path
      d="M59.4727 37.9492H70.5908V46.2168H59.4727V37.9492Z"
      fill="#EBEEF4"
    />
    <path
      d="M59.4727 48.2168H70.5908V56.4844H59.4727V48.2168Z"
      fill="#EBEEF4"
    />
    <path d="M59.4727 58.4844H70.5908V66.752H59.4727V58.4844Z" fill="#EBEEF4" />
    <path d="M72.5908 17.4141H83.709V25.6816H72.5908V17.4141Z" fill="#EBEEF4" />
    <path d="M72.5908 27.6816H83.709V35.9492H72.5908V27.6816Z" fill="#EBEEF4" />
    <path d="M72.5908 37.9492H83.709V46.2168H72.5908V37.9492Z" fill="#EBEEF4" />
    <path d="M72.5908 48.2168H83.709V56.4844H72.5908V48.2168Z" fill="#EBEEF4" />
    <path d="M72.5908 58.4844H83.709V66.752H72.5908V58.4844Z" fill="#EBEEF4" />
    <path
      d="M85.709 17.4141H94.8271C95.9317 17.4141 96.8271 18.3095 96.8271 19.4141V23.6816C96.8271 24.7862 95.9317 25.6816 94.8271 25.6816H85.709V17.4141Z"
      fill="#EBEEF4"
    />
    <path
      d="M85.709 27.6816H94.8271C95.9317 27.6816 96.8271 28.5771 96.8271 29.6816V33.9492C96.8271 35.0538 95.9317 35.9492 94.8271 35.9492H85.709V27.6816Z"
      fill="#EBEEF4"
    />
    <path
      d="M85.709 37.9492H94.8271C95.9317 37.9492 96.8271 38.8446 96.8271 39.9492V44.2168C96.8271 45.3214 95.9317 46.2168 94.8271 46.2168H85.709V37.9492Z"
      fill="#EBEEF4"
    />
    <path
      d="M85.709 48.2168H94.8271C95.9317 48.2168 96.8271 49.1122 96.8271 50.2168V54.4844C96.8271 55.5889 95.9317 56.4844 94.8271 56.4844H85.709V48.2168Z"
      fill="#EBEEF4"
    />
    <path
      d="M85.709 58.4844H94.8271C95.9317 58.4844 96.8271 59.3798 96.8271 60.4844V64.752C96.8271 65.8565 95.9317 66.752 94.8271 66.752H85.709V58.4844Z"
      fill="#EBEEF4"
    />
  </svg>
);
